export default "__VITE_ASSET__BnyZAef3__"